// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 781 ? "lazyChart" : chunkId) + "." + {"9":"aaa2685a","88":"1d2d9888","537":"77dd1891","781":"5a044690","925":"05024059","962":"368f429e","987":"81d9695c"}[chunkId] + ".chunk.js";
};